export default "__VITE_ASSET__CZ_f2fVi__"